export var ContactExtractors = {
    id: function (u) { return u.id; },
    name: function (u) { return u.name; },
    emails: function (u) { return u.emails.join(", "); },
    avatarUrl: function (u) { var _a, _b; return (_b = (_a = u.avatar) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : undefined; },
};
